<template>
    <v-content :class="`account-info`" v-if="user">
        <h2>
            <typo name="title-30-normal"> Modifier mon mot de passe </typo>
        </h2>
        <sep name="M"></sep>
        <v-card elevation="0">
            <v-card-text>
                <v-form ref="form" class="form" v-model="valid">
                    <v-container>
                        <v-row>
                            <v-col>
                                <password-text-field
                                    v-model="values.oldPassword"
                                    label="Ancien mot de passe*"
                                    required
                                    :rules="[required]"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <password-text-field
                                    v-model="values.password"
                                    label="Nouveau mot de passe*"
                                    required
                                    :rules="[required, password]"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <password-text-field
                                    v-model="values.passwordConfirmation"
                                    label="Répéter le mot de passe*"
                                    required
                                    :rules="[required, equals(values.password)]"
                                />
                            </v-col>
                        </v-row>
                        <div class="actions">
                            <action name="main" @click="validate">Modifier</action>
                        </div>
                        <typo class="legend" name="body-12-normal">
                            <i>Les champs marqués d’une * sont obligatoires</i>
                        </typo>
                        <typo class="legend" name="body-12-normal">
                            <i>
                                Le mot de passe doit comporter au moins 8 caractères et doit
                                contenir un caractère spécial, un nombre et une majuscule
                            </i>
                        </typo>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-content>
</template>

<script>
import Vue from "vue";
import { required, equals, password } from "src/utils/vform-rules";
import { EventBus } from "src/bus/eventBus";
import PasswordTextField from "src/components/common/form/PasswordTextField.vue";
import userMixin from "src/mixins/user";

export default Vue.extend({
    props: ["user"],
    components: {
        PasswordTextField,
    },
    data() {
        return {
            valid: true,
            required: required,
            equals: equals,
            password: password,
            values: {
                oldPassword: "",
                password: "",
                passwordConfirmation: "",
            },
        };
    },
    mixins: [userMixin],
    methods: {
        async validate() {
            if (this.$refs.form.validate()) {
                try {
                    await this.updatePassword(this.values);
                    EventBus.$emit("alert:success", { message: "Mot de passe changé" });
                } catch (e) {
                    if (e) {
                        EventBus.$emit("alert:error", { message: e.payload.message });
                    }
                }
            }
        },
    },
});
</script>

<style lang="sass" scoped>
.form
    max-width: 700px
    margin: 0

.actions
    display: flex
    justify-content: flex-start

.legend
    margin-top: $grid-gutter
    display: inline-block
</style>
